import { track } from './send'

export default class Click {
  add (entry) {
    entry.el.addEventListener('click', function () {
      track([entry.el.trackParams])
    })
  }

  update (entry) {
    /* eslint-disable */
    entry.el.trackParams = entry.el.trackParams;
  }
}
